import Vue from "vue";
import Vuex from "vuex";
import COMPANY from "@/services/admin/companies";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    companies: [],
    selectedCompany: null,
  },
  getters: {
    selectedCompany: (state) =>
      state.companies.find(
        (company) => company.id === state.selectedCompany
      ),
    companies: (state) => state.companies,
  },
  mutations: {
    setCompanies(state, companies) {
      state.companies = companies;
    },
    selectCompany(state, company_id) {
      state.selectedCompany = company_id;
    },
  },
  actions: {
    async selectCompany({ commit }, company_id) {
      return commit("selectCompany", company_id);
    },
    async getAllCompanies({ commit }) {
      const response = await COMPANY.getAll();
      commit("setCompanies", response.companies);
      return response.companies;
    },
  },
};
